import {Component, OnInit} from '@angular/core';
import {AuthService} from '@hassel-it/angular-common';
import {PermissionsService} from '../permissions.service';
import {environment} from '../../environments/environment';
import {NotificationsService} from '../services/notifications.service';

@Component({
    selector: 'app-shipment-system-simplenav',
    templateUrl: './shipment-system-simplenav.component.html',
    styleUrls: ['./shipment-system-simplenav.component.scss']
})
export class ShipmentSystemSimplenavComponent implements OnInit {
    public environment: { assetBase: string; production: boolean; apiBase: string; locale: string };
    public unreadCount = 0;

    constructor(
        public authService: AuthService,
        public permissionsService: PermissionsService,
        private notificationsService: NotificationsService
    ) {
        this.environment = environment;
    }

    ngOnInit() {
        this.permissionsService.buildPermissions();
        this.loadUnreadCount();
    }

    loadUnreadCount() {
        this.notificationsService.getUnreadNotificationsCount().then(count => {
            this.unreadCount = count;
        });
    }

    logout() {
        this.authService.logout('/', true).subscribe((d) => {
            window.location.reload();
        });
    }
}
